import { NonAuthorizedContentWithImageLayout } from '@/bo-kit/components/NonAuthorizedContentWithImageLayout';
import { useTranslation } from '@/ui-kit/hooks/useTranslation';
import { FC } from 'react';
import { Form } from '@/bo-kit/components/SignInPage/components/Form';
import { ImageSlider } from '@/bo-kit/components/ImageSlider';
import { PageTitle } from '@/ui-kit/components';

export const SignInPageResponsive: FC<{ implementation?: 'css' | 'js' }> = ({ implementation }) => {
    const { t } = useTranslation('bo-kit__common');
    return (
        <NonAuthorizedContentWithImageLayout
            title={t('Sign In')}
            implementation={implementation}
            content={
                <>
                    <PageTitle>{t('Welcome!')}</PageTitle>
                    <Form />
                </>
            }
            image={<ImageSlider />}
        />
    );
};

// ADHOC: support lazy import
export default SignInPageResponsive;
